import { defineMessages } from 'react-intl';

export default defineMessages({
    AddNewInsuredCandidate: {
        id: 'common.controllers.MLInsuredCandidatesComponent.Add Insured Candidate Not Listed',
        defaultMessage: 'Name not listed - Add new'
    }
});
